import AnalyticsGroupWidgetLoader from "../../../components/widgetLoader/analyticsGroupWidgetLoader";
import LazyAnalyticsWidgetLoader from "../../../components/widgetLoader/lazyAnalyticsWidgetLoader";
import Resizer from "./resizer";
import { MdControlCamera } from "react-icons/md";
import ExtAProvider from "../../../features/extendedASSRM/components/extAProvider";

const WidgetLoader = ({ widget, dashboard, dashboardWidget }) => {
  return widget.render_type === "group" ? (
    <ExtAProvider>
      <AnalyticsGroupWidgetLoader widgetMeta={widget} />
      <div className="resizer">
        <Resizer />
      </div>
      <div className="drag-handle">
        <MdControlCamera />
      </div>
    </ExtAProvider>
  ) : (
    <ExtAProvider>
      <LazyAnalyticsWidgetLoader
        dashboard={dashboard}
        dashboardWidget={dashboardWidget}
        widget={widget}
      />
      <div className="resizer">
        <Resizer />
      </div>
      <div className="drag-handle">
        <MdControlCamera />
      </div>
    </ExtAProvider>
  );
};

export default WidgetLoader;
